if (!customElements.get('cartui-shipping-estimate')) {
  const holidaysCache = {};
  const holidaysPending = {};

  class CartUIShippingEstimate extends HTMLElement {
    constructor() {
      super();
      this.locale = this.getUserLocale();
    }

    connectedCallback() {
      this.businessDays = parseInt(this.dataset.businessDays || '7', 10);
      this.countryCode = (this.dataset.countryCode || 'FR').toUpperCase();
      this.timeZone = this.dataset.timezone || 'Europe/Paris';

      this.render();
    }

    async render() {
      const estimatedDate = await this.getDeliveryEstimateDate();
      if (!estimatedDate) {
        console.warn('Erreur récupération date de livraison');
        return;
      }
      const formatted = estimatedDate.toLocaleDateString(this.locale, {
        // weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

      this.textContent = formatted;
    }

    getUserLocale() {
      return document.documentElement.lang || navigator.language || 'fr-FR';
    }

    getWeekendDays(countryCode) {
      const weekendMap = {
        SA: [5, 6],
        AE: [6, 0],
        IL: [5, 6],
        IN: [0],
        default: [0, 6],
      };

      return weekendMap[countryCode] || weekendMap.default;
    }

    formatDateToISO(date, timeZone) {
      const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
      const year = tzDate.getFullYear();
      const month = String(tzDate.getMonth() + 1).padStart(2, '0');
      const day = String(tzDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    async getPublicHolidays(year, countryCode) {
      const cacheKey = `${countryCode}_${year}`;

      if (holidaysCache[cacheKey]) {
        return holidaysCache[cacheKey];
      }

      if (holidaysPending[cacheKey]) {
        return holidaysPending[cacheKey];
      }

      const localCache = localStorage.getItem(`holidays_${cacheKey}`);
      if (localCache) {
        const parsed = JSON.parse(localCache);
        holidaysCache[cacheKey] = parsed;
        return parsed;
      }

      const fetchPromise = fetch(
        `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`,
      )
        .then((res) => {
          if (!res.ok)
            throw new Error(
              `Erreur récupération jours fériés pour ${countryCode}`,
            );
          return res.json();
        })
        .then((data) => {
          const dates = data.map((d) => d.date);
          holidaysCache[cacheKey] = dates;
          localStorage.setItem(`holidays_${cacheKey}`, JSON.stringify(dates));
          delete holidaysPending[cacheKey];
          return dates;
        })
        .catch((error) => {
          delete holidaysPending[cacheKey];
          throw error;
        });

      holidaysPending[cacheKey] = fetchPromise;
      return fetchPromise;
    }

    async getDeliveryEstimateDate() {
      if (!this.businessDays || !this.countryCode || !this.timeZone) {
        console.warn('Business days, country code, or timezone not set');
        return null;
      }

      const holidays = {};
      const weekends = this.getWeekendDays(this.countryCode);
      let current = new Date();
      let added = 0;

      while (added < this.businessDays) {
        current.setDate(current.getDate() + 1);
        const year = current.getFullYear();

        if (!holidays[year]) {
          holidays[year] = await this.getPublicHolidays(year, this.countryCode);
        }

        const iso = this.formatDateToISO(current, this.timeZone);
        const isHoliday = holidays[year].includes(iso);
        const isWeekend = weekends.includes(current.getDay());

        if (!isHoliday && !isWeekend) {
          added++;
        }
      }

      return current;
    }
  }

  customElements.define('cartui-shipping-estimate', CartUIShippingEstimate);
}
